import React from 'react';
import PropTypes from 'prop-types';

const BusinessMethod = (props) => {
  return (
    <div className="slds-size_1-of-3 slds-col">
      <textarea
        className="slds-textarea"
        rows="4"
        value={props.value}
        onChange={props.onChange}
      ></textarea>

      <div
        style={{ marginTop: '5px', color: '#aaaaaa' }}
        className="margin-b slds-text-heading_small"
      >
        {props.children}
      </div>
    </div>
  );
};

BusinessMethod.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default BusinessMethod;
